import { v1 } from 'uuid'

function countDay(mount: any) {
  let today = new Date()
  today.setDate(today.getDate() + mount)
  return today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
}
export function formatShortTime(date: string) {
  if (!date) {
    return ''
  } else {
    let d = date.substring(0, 10) // 2020-07-07
    let t = date.substring(11, 16)
    let a = d.split('-') // ['年', '月', '日']
    let currYear = new Date().getFullYear() + '' // 当前时间的年
    let currMonth = (new Date().getMonth() + 1) > 9 ? '' + (new Date().getMonth() + 1) : '0' + (new Date().getMonth() + 1)
    let currDate = new Date().getDate() > 9 ? '' + new Date().getDate() : '0' + new Date().getDate()
    let currentTime = new Date().getTime()
    let dday = new Date(date).getTime()
    let diff = dday - currentTime
    let day = Math.abs(diff / 1000 / 3600 / 24) // 计算日期
    let hour = Math.abs(diff / 1000 / 3600) // 计算小时
    let minutes = Math.abs(diff / 1000 / 60) // 计算分钟
    let seconds = Math.abs(diff / 1000) // 计算秒

    if (currYear !== a[0]) { // 如果传入的日期的年份不等于当前日期的年份 那么直接返回date
      return date
    } else { // 如果年份相等 判定日期的月份是否相等
      if (currMonth !== a[1]) { // 如果年相等，月不相等 直接返回月 日 和时间
        return `${a[1]}-${a[2]} ${t}`
      } else { // 如果年相等，月相等
        if (currDate !== a[2]) { // 如果日不相等
          if (Number(currDate) - Number(a[2]) === 1) { // 如果传入进来的日期等于昨天 显示昨天 否则 显示 月 日 加时间
            return `昨天${t}`
          } else {
            return `${a[1]}-${a[2]} ${t}`
          }
        } else { // 如果日相等
          if (seconds > 0 && seconds < 60) {
            return parseInt(seconds + '', 10) + '秒前'
          } else if (minutes > 0 && minutes < 60) {
            return `${parseInt(minutes + '', 10)}分钟前`
          } else if (hour > 0 && hour < 24) {
            return `今日${t}`
          }
        }
      }
    }
  }
  return ''
}
export function transColor(color: string) {
  let str = color.replace('#', '')
  let uCloor = parseInt(str, 16)
  let r = (uCloor >> 16) & 0xFF
  let g = (uCloor >> 8) & 0xFF
  let b = uCloor & 0xFF
  return `linear-gradient(to bottom, rgba(${r}, ${g}, ${b}, 0.75) 0%, rgba(${r}, ${g}, ${b}, 1) 100%)`
}
export function getCurrentDate(time?: Date) {
  let date = time
  if (!date) {
    date = new Date()
  }
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  const monthTrue = month + 1 > 9 ? month + 1 : '0' + (month + 1)
  const dayTrue = day > 9 ? day : '0' + day
  return year + '-' + monthTrue + '-' + dayTrue
}
export function getFormatDate(date: any, type?: string) {
  if (typeof date === 'string') {
    date = new Date(date)
  }
  const year = date.getFullYear()
  let month = date.getMonth()
  let day = date.getDate()
  month = month + 1 > 9 ? month + 1 : '0' + (month + 1)
  day = day > 9 ? day : '0' + day
  if (type === 'date') {
    return year + '-' + month + '-' + day
  }
  let hour = date.getHours()
  let minites = date.getMinutes()
  let second = date.getSeconds()
  hour = hour > 9 ? hour : '0' + hour
  minites = minites > 9 ? minites : '0' + minites
  second = second > 9 ? second : '0' + second
  return year + '-' + month + '-' + day + ' ' + hour + ':' + minites + ':' + second
}
/*
** randomWord 产生任意长度随机字母数字组合
** randomFlag 是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
*/
export function randomWord(randomFlag: boolean, min: number, max?: number) {
  let str = ''
  let range = min
  const arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
  if (randomFlag && max) {
    range = Math.round(Math.random() * (max - min)) + min
  }
  for (let i = 0; i < range; i++) {
    const pos = Math.round(Math.random() * (arr.length - 1))
    str += arr[pos]
  }
  return str
}
export function getDurationDate(month: number | string, endDate?: Date) {
  const end = endDate || new Date()
  const start = new Date()
  end.setMonth(end.getMonth() + Number(month))
  return [getCurrentDate(start), getCurrentDate(end)]
}
export const Base64 = {
  _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
  encode: (input: any) => {
    let output = ''
    let i = 0
    input = Base64._utf8_encode(input)
    while (i < input.length) {
      let chr1 = input.charCodeAt(i++)
      let chr2 = input.charCodeAt(i++)
      let chr3 = input.charCodeAt(i++)
      let enc1 = chr1 >> 2
      let enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
      let enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
      let enc4 = chr3 & 63
      if (isNaN(chr2)) {
        enc3 = 64
        enc4 = 64
      } else if (isNaN(chr3)) {
        enc4 = 64
      }
      output = output +
        Base64._keyStr.charAt(enc1) + Base64._keyStr.charAt(enc2) +
        Base64._keyStr.charAt(enc3) + Base64._keyStr.charAt(enc4)
    }
    return output
  },
  decode: (input: any) => {
    let output = ''
    let i = 0
    // todo []中括号里面使用转移符是多余的
    // input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '')
    input = input.replace(/[^A-Za-z0-9\u002b\u002f\u003d]/g, '')
    while (i < input.length) {
      let enc1 = Base64._keyStr.indexOf(input.charAt(i++))
      let enc2 = Base64._keyStr.indexOf(input.charAt(i++))
      let enc3 = Base64._keyStr.indexOf(input.charAt(i++))
      let enc4 = Base64._keyStr.indexOf(input.charAt(i++))
      let chr1 = (enc1 << 2) | (enc2 >> 4)
      let chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
      let chr3 = ((enc3 & 3) << 6) | enc4
      output = output + String.fromCharCode(chr1)
      if (enc3 !== 64) {
        output = output + String.fromCharCode(chr2)
      }
      if (enc4 !== 64) {
        output = output + String.fromCharCode(chr3)
      }
    }
    output = Base64._utf8_decode(output)
    return output
  },
  _utf8_encode: (string1: string) => {
    let str = string1.replace(/\r\n/g, '\n')
    let utftext = ''
    for (let n = 0; n < str.length; n++) {
      let c = str.charCodeAt(n)
      if (c < 128) {
        utftext += String.fromCharCode(c)
      } else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192)
        utftext += String.fromCharCode((c & 63) | 128)
      } else {
        utftext += String.fromCharCode((c >> 12) | 224)
        utftext += String.fromCharCode(((c >> 6) & 63) | 128)
        utftext += String.fromCharCode((c & 63) | 128)
      }
    }
    return utftext
  },
  _utf8_decode: (utftext: string) => {
    let str = ''
    let i = 0
    let [c, c2, c3] = [0, 0, 0]
    while (i < utftext.length) {
      c = utftext.charCodeAt(i)
      if (c < 128) {
        str += String.fromCharCode(c)
        i++
      } else if ((c > 191) && (c < 224)) {
        c2 = utftext.charCodeAt(i + 1)
        str += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
        i += 2
      } else {
        c2 = utftext.charCodeAt(i + 1)
        c3 = utftext.charCodeAt(i + 2)
        str += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63))
        i += 3
      }
    }
    return str
  }
}
// 省市县 一级，二级，三级深度处理
export function deepRegion(options, deep = 1, regionType) {
  return options.map(({ name, children }) => {
    let item: any = { text: name }
    if (deep === regionType || children === null) {
      delete item.children
    } else {
      item.children = deepRegion(children, deep + 1, regionType)
    }
    return item
  })
}
// 展示权限判断
export function authorityShow(isAdmin, viewAuthority, fieldAuthority, type?: string) {
  if (isAdmin) {
    return true
  }
  if (type === 'add') {
    let { canAdd } = fieldAuthority || {}
    return canAdd
  } else {
    let { canRead } = viewAuthority || {}
    if (canRead) {
      let canRead1 = (fieldAuthority || {}).canRead
      return canRead1
    }
  }
}
// 只读权限判断
export function authorityEdit(isAdmin, viewAuthority, fieldAuthority, type?: string) {
  if (isAdmin) {
    return true
  }
  if (type === 'add') {
    return true
  } else {
    let { canEdit } = viewAuthority || {}
    if (canEdit) {
      let canEdit1 = (fieldAuthority || {}).canEdit
      return canEdit1
    }
  }
}
// 生产不带-的uuid
export function uuid() {
  return v1().replace(/-/g, '')
}
export function isUndef(v: any): boolean {
  return v === undefined || v === null
}

export class Progress {
  private time: number = 0
  private $textContainer
  private $bar
  constructor(editor) {
    this.$textContainer = editor.$textContainerElem
    this.$bar = document.createElement('div')
    this.$bar.setAttribute('class', 'w-e-progress')
    this.$textContainer[0].appendChild(this.$bar)
  }
  public show(progress) {
    // 状态处理

    // 改变进度（节流，100ms 渲染一次）
    if (Date.now() - this.time > 100) {
      if (progress <= 1) {
        this.$bar.style.width = `${progress * 100}%`
        this.time = Date.now()
      }
    }
    if (progress >= 1) {
      this.hide()
    }
  }

  public hide() {
    const $bar = this.$bar
    // 修改状态
    $bar.remove()
  }
}
export function getOptionArrFromOption(ids, options, OptionArr: any = []) {
  if (!ids[0]) {
    return OptionArr
  }
  for (let i = 0; i < options.length; i++) {
    let item = options[i]
    if (item.key === ids[0]) {
      OptionArr.push(item)
      ids.shift()
      getOptionArrFromOption([...ids], item.children || [], OptionArr)
      break
    }
  }
  return OptionArr
}
export function getLabelFromOption(ids, options, labels: any = []) {
  if (!ids[0]) {
    return labels
  }
  for (let i = 0; i < options.length; i++) {
    let item = options[i]
    if (item.key === ids[0]) {
      labels.push(item.value)
      ids.shift()
      getLabelFromOption([...ids], item.children || [], labels)
      break
    }
  }
  return labels
}
export function toHash(array, keyName, valueName) {
  return array.reduce((dictionary, next) => {
    dictionary[next[keyName]] = next[valueName];
    return dictionary;
  }, {});
}

export function getUserId() {
  return window.localStorage.getItem('userId') || ''
}
export function getCompanyId() {
  return window.localStorage.getItem('companyId') || ''
}
export function getCurrentYear() {
  return (new Date()).getFullYear()
}
export function afterLogout() {
  window.sessionStorage.clear()
  window.location.href = '/'
}

// 多层关联字段嵌套递归
export const newRecursion = (sourceField) => {
  if (sourceField && sourceField.fieldType === 'associationField') {
    const newsourceField = newRecursion(sourceField.sourceField);
    newsourceField.name = sourceField.name
    return newsourceField
  } else {
    return sourceField;
  }
}
